import React from "react";

// components

export default function CardSettings() {
  return (
    <>
      <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-gray-200 border-0">
        <div className="rounded-t bg-white mb-0 px-6 py-6">
          <div className="text-center flex justify-between">
            <h6 className="text-gray-800 text-xl font-bold">CONTACT</h6>
          </div>
        </div>
        <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
          <form>
            <h6 className="text-gray-500 text-sm mt-3 mb-6 font-bold uppercase">              
            </h6>
            <div className="flex flex-wrap">
              <div className="w-full lg:w-6/12 px-4">
                <div className="relative w-full mb-3">
                  <label
                    className="block uppercase text-gray-700 text-xs font-bold mb-2"
                    htmlFor="grid-password"
                  >
                    Any Problem or Suggestion?
                  </label>
                  There are several ways you can reach us.<br/><br/>
                  <b>Email:</b> mblinktools@gmail.com<br/>
                  <b>Skype:</b> astronbnx<br/>
                  <b>Whatsapp:</b> +1 (650) 772-0618<br/>
                  (No phone calls, just text messages will be replied)<br/>
                  <b>Available Hours:</b> 11:00 AM - 13:00 PM (GMT+3) on Weekdays<br/>
                  All messages outside these hours are read daily and responded to later.
                </div>
              </div>
              <div className="w-full lg:w-6/12 px-4">
                <div className="relative w-full mb-3">
                      <img
                        src={require("assets/img/mblinkapp.jpg")}
                        className="h-auto shadow bg-white border"
                        alt="..."
                      ></img>{" "}
                </div>
              </div>              
            </div>

            <hr className="mt-6 border-b-1 border-gray-400" />

          </form>
        </div>
      </div>
    </>
  );
}
